<template>
  <v-row class="pa-6">
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1">Institutional Claims</div>
          <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :sort-by="'CLAIM_DATE'"
          :sort-desc="true"
          :items="provider_data"
          :search="search"
        >
          <template v-slot:item.CLAIM_ID="{ item }">
            <v-chip small @click="openClaimDetails(item.CLAIM_ID)">
              {{ item.CLAIM_ID }}
            </v-chip>
          </template>

          <template v-slot:item.AMOUNT_DEC="{ item }">
            <v-chip v-if="insurance == 'Humana'" small @click="openClaimFundTypes(item.CLAIM_ID)">
              {{ item.AMOUNT }}
            </v-chip>
            <span v-else>{{ item.AMOUNT }}</span>
          </template>

          <template v-slot:no-data> No Claims </template>
        </v-data-table>

        <ClaimDetails
          :insurance="insurance"
          :claimID="claimDetailsID"
          v-model="claimDetailsDialog"
        />
        <ClaimFundTypes
          :insurance="insurance"
          :claimID="claimFundsClaimID"
          patientID=""
          v-model="claimFundTypesDialog"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
import ClaimDetails from '../claimDetails.vue';
import ClaimFundTypes from '../claimFundTypes.vue';

export default {
  name: 'Institutional',
  props: ['provider', 'insurance', 'startDate', 'endDate'],
  components: {
    ClaimDetails,
    ClaimFundTypes,
  },
  data() {
    return {
      search: '',
      loading: false,
      claimFundTypesDialog: false,
      claimFundsClaimID: '',
      claimDetailsDialog: false,
      claimDetailsID: '',
      headers: [
        {
          text: 'Claim ID',
          sortable: false,
          value: 'CLAIM_ID',
        },
        { text: 'Claim Date', value: 'CLAIM_DATE' },
        { text: 'Patient Name', value: 'MEMBER_NAME' },
        { text: 'Facility', value: 'FACILITY' },
        { text: 'Primary Diag. Code', value: 'PRIMARY_DIAG' },
        { text: 'Diagnosis Description', value: 'DIAG_DESC' },
        { text: 'Place of Service', value: 'PLACE_OF_SERVICE' },
        { text: 'Admission', value: 'ADMISSION' },
        { text: 'Cost', value: 'AMOUNT_DEC' },
        { text: 'Line EOP Description', value: 'LINE_EOP_DESC' },
        { text: 'EOP Description', value: 'EOP_DESC' },
      ],
      provider_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getClaims() {
      this.provider_data = [];
      this.loading = true;
      await axios
        .get(
          `api/provider/claims/institutional/${this.insurance}/${this.provider}/${this.startDate}/${this.endDate}`
        )
        .then((response) => {
          this.provider_data = response.data;
          this.loading = false;
        });
    },
    async openClaimDetails(ID) {
      this.claimDetailsDialog = true;
      this.claimDetailsID = ID;
    },
    async openClaimFundTypes(ID) {
      this.claimFundTypesDialog = true;
      this.claimFundsClaimID = ID;
    },
  },
  watch: {
    async startDate() {
      this.getClaims();
    },
    async endDate() {
      this.getClaims();
    },
  },
};
</script>
